export default "__VITE_ASSET__66441a29__"